import { render, staticRenderFns } from "./Consignment.vue?vue&type=template&id=047f875b&"
import script from "./Consignment.vue?vue&type=script&lang=js&"
export * from "./Consignment.vue?vue&type=script&lang=js&"
import style0 from "./Consignment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Consignment.vue"
export default component.exports